export default "__VITE_ASSET__B1fZ2MqL__"